import { z } from 'zod';
/**
 * Background work, as the browser sees it. Everything paid or heavy runs as a Job, so
 * this is also what the global activity indicator is reading.
 */
export const JobKindSchema = z.enum([
    'scan.inventory',
    'ingest.reference',
    'generate.candidate',
    'render.animatic',
    'render.video',
    'transform.image',
    'check.technical',
    'package.export',
    'extract.evidence',
    'extract.learning',
    'bulk.cell',
]);
/**
 * `needsAttention` is not a degree of failure. It is work whose outcome is unknown,
 * where sending it again is the expensive mistake, so it waits for the operator.
 */
export const JobStateSchema = z.enum(['queued', 'working', 'succeeded', 'failed', 'needsAttention', 'cancelled']);
export const JobLaneSchema = z.enum(['experiment', 'bulkRun']);
/** The states a Job can still move out of, and so the ones an operator is waiting on. */
export const ACTIVE_JOB_STATES = ['queued', 'working'];
export function isJobActive(state) {
    return ACTIVE_JOB_STATES.includes(state);
}
export const ActivityJobSchema = z.object({
    id: z.string().min(1),
    kind: JobKindSchema,
    state: JobStateSchema,
    version: z.number().int().nonnegative(),
    subjectKind: z.string().min(1),
    subjectId: z.string().min(1),
    appId: z.string().nullable(),
    experimentId: z.string().nullable(),
    bulkRunId: z.string().nullable(),
    attempt: z.number().int().nonnegative(),
    /** One plain line. The provider, the model and the status code stay in `details`. */
    message: z.string().nullable(),
    details: z.record(z.string(), z.unknown()).nullable(),
    at: z.string().min(1),
});
/**
 * The REST snapshot the browser reconciles its buffered events against. There is no
 * journal replay: this is the current truth, and every entry carries the version an
 * event has to beat to be applied.
 */
export const ActivitySnapshotSchema = z.object({
    at: z.string().min(1),
    activeCount: z.number().int().nonnegative(),
    jobs: z.array(ActivityJobSchema),
});
/** The resource name every Job event carries on the stream. */
export const JOB_RESOURCE = 'job';
export const ACTIVITY_PATH = '/api/v1/events/activity';
//# sourceMappingURL=activity.js.map